import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, switchMap } from 'rxjs';
import { OpportunityApproval } from '@/models/opportunity-approval.model';
import { CreateOpportunityApprovalDto } from '@/shared/dto/create-opportunity-approval.dto';
import { UpdateOpportunityApprovalDto } from '@/shared/dto/update-opportunity-approval.dto';
import { CreateOpportunityApprovalsBatchDto } from '@/shared/dto/create-opportunity-approvals-batch.dto';

@Injectable({ providedIn: 'root' })
export class OpportunityApprovalsService {
  private apiUrl = `${window.location.origin}/api/opportunity`;

  constructor(
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService
  ) {}

  getApprovals(opportunityId: number): Observable<OpportunityApproval[]> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<OpportunityApproval[]>(`${this.apiUrl}/${opportunityId}/approvals`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  createApproval(opportunityId: number, dto: CreateOpportunityApprovalDto): Observable<OpportunityApproval> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.post<OpportunityApproval>(`${this.apiUrl}/${opportunityId}/approvals`, dto, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  createApprovalsBatch(opportunityId: number, dto: CreateOpportunityApprovalsBatchDto): Observable<OpportunityApproval[]> {
    console.debug('[OpportunityApprovalsService] createApprovalsBatch called', { opportunityId, dto });
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) => {
        console.debug('[OpportunityApprovalsService] createApprovalsBatch HTTP POST', {
          url: `${this.apiUrl}/${opportunityId}/approvals/batch`,
          dto,
          idToken,
        });
        return this.http.post<OpportunityApproval[]>(`${this.apiUrl}/${opportunityId}/approvals/batch`, dto, {
          headers: { Authorization: `Bearer ${idToken}` },
        });
      })
    );
  }

  updateApproval(approvalId: number, dto: UpdateOpportunityApprovalDto): Observable<OpportunityApproval> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.patch<OpportunityApproval>(`${window.location.origin}/api/opportunity-approval/${approvalId}`, dto, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  deleteApproval(approvalId: number): Observable<void> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.delete<void>(`${window.location.origin}/api/opportunity-approval/${approvalId}`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }
}
